
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { getRevenueActivity } from "./revenueActivity.api";
import type { RevenueActivityData } from "./components/revenueActivity.types";
import RevenueHistoryModal from "./components/RevenueHistoryModal";

import "./RevenueActivity.css";

function RevenueActivity() {
  const [activity, setActivity] = useState<RevenueActivityData | null>(null);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const loadActivity = async () => {
      try {
        const result = await getRevenueActivity(controller.signal);

        if (!controller.signal.aborted) {
          setActivity(result);
          setHasError(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          console.error("Error cargando recaudación:", error);
          setHasError(true);
        }
      }
    };

    void loadActivity();

    const intervalId = window.setInterval(() => {
      void loadActivity();
    }, 60_000);

    return () => {
      controller.abort();
      window.clearInterval(intervalId);
    };
  }, []);

  const formattedAmount = activity
    ? new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
      }).format(activity.totalCollected)
    : null;

  return (
    <>
      <div className="revenue-activity">
        <span className="revenue-activity__label">
          Recaudado {activity?.currentYear ?? ""}
        </span>

        <span className="revenue-activity__amount">
          {formattedAmount ??
            (hasError ? "No disponible" : "Cargando...")}
        </span>

        <button
          type="button"
          className="revenue-activity__history-button"
          onClick={() => setIsHistoryOpen(true)}
          aria-label="Ver histórico de recaudación"
        >
          Ver histórico
        </button>
      </div>

      {isHistoryOpen && activity &&
        createPortal(
          <RevenueHistoryModal
            currentYear={activity.currentYear}
            yearlyCollections={activity.yearlyCollections}
            onClose={() => setIsHistoryOpen(false)}
          />,
          document.body
        )}

      {isHistoryOpen && !activity &&
        createPortal(
          <div className="revenue-modal-overlay">
            <section
              className="revenue-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="revenue-loading-title"
            >
              <header className="revenue-modal__header">
                <div>
                  <h2 id="revenue-loading-title">
                    Histórico de recaudación
                  </h2>

                  <p>
                    {hasError
                      ? "No se ha podido cargar el histórico."
                      : "Cargando datos de recaudación..."}
                  </p>
                </div>

                <button
                  type="button"
                  className="revenue-modal__close"
                  onClick={() => setIsHistoryOpen(false)}
                  aria-label="Cerrar ventana"
                >
                  ×
                </button>
              </header>
            </section>
          </div>,
          document.body
        )}
    </>
  );
}

export default RevenueActivity;
